module.exports = __webpack_public_path__ + "static/media/croissants.40a06e9f.JPG";